export default {
  hero: {
    title: '全网最新',
    titleHighlight: '吃瓜入口',
    subtitle: '独家爆料 · 实时追踪 · 每日更新',
    description: '明星绯闻、综艺内幕、影视动态、网红八卦，你想吃的瓜，这里全都有！',
    cta: '立即吃瓜',
    secondaryCta: '了解更多',
  },
  hotTopics: {
    title: '今日最热',
    titleHighlight: '八卦',
    subtitle: '全网最火爆的娱乐八卦资讯，每日实时更新',
  },
  latestNews: {
    title: '最新',
    titleHighlight: '爆料',
    subtitle: '持续更新中，不错过任何一个瓜',
    loadMore: '加载更多',
  },
  categoryNav: {
    title: '探索',
    titleHighlight: '频道',
    subtitle: '按你的口味挑选，总有一款瓜适合你',
  },
  newsletter: {
    title: '想吃',
    titleHighlight: '第一手瓜',
    subtitle: '订阅51吃瓜官网，最新八卦推送到你手中，绝不让你落下一口瓜！',
    placeholder: '输入你的邮箱地址',
    button: '立即订阅',
    privacy: '我们尊重你的隐私，绝不发送垃圾邮件',
  },
}